import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postGrades({ body }) {
  return BaseService.post(REST.GRADES, body);
}

function putGrades({ body, id }) {
  return BaseService.put(REST.GRADES_ID(id), body);
}

function getGrades(params) {
  return BaseService.get(REST.GRADES, {
    params: paramsFilter({ params }),
  });
}

function deleteGrades({ id }) {
  return BaseService.delete(REST.GRADES_ID(id));
}

export default {
  postGrades,
  putGrades,
  getGrades,
  deleteGrades,
};
